<script lang="ts" setup>
	interface Props {
		profiles: { src: string; active?: boolean; name?: string }[]
	}

	const { isMobile } = useMobile()
	defineProps<Props>()
</script>
<template>
	<div class="flex flex-col items-center justify-center gap-5 pb-5">
		<tools-carousel
			:carousel-list="profiles"
			:options="{
				mediaQuery: 'min',
				perPage: 1,
				gap: 20,
				autoWidth: true,
				focus: 'center',
				breakpoints: { 767: { gap: 0 } },
				role: ''
			}"
			:indicator="{ on: isMobile }"
		>
			<template #default="{ item }">
				<div
					class="relative w-full sm:max-w-[240px] lg:max-w-[300px] sm:h-[320px] snap-proximity group max-w-[220px] h-[210px] overflow-hidden rounded-lg flex-none"
					:class="{
						'sm:-scale-90 sm:rotate-180': !item.active
					}"
				>
					<nuxt-img
						:src="item.src"
						:alt="item?.name ?? 'user-profile'"
						class="object-cover w-full"
						fetchpriority="high"
					/>
				</div>
			</template>
		</tools-carousel>
	</div>
</template>
